import { store as patient } from './patient'

const modules = {
  patient
}

export default {
  namespaced: true,
  modules
}



// WEBPACK FOOTER //
// ./src/app/store.js